import { render, staticRenderFns } from "./claimSetups.vue?vue&type=template&id=10bdc0ee"
import script from "./claimSetups.vue?vue&type=script&lang=js"
export * from "./claimSetups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports